<template>
  <footer class="bg-gray-800 mt-auto">
    <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
      <div class="mt-8 md:mt-0 md:order-1">
        <p class="text-center text-base text-gray-300">&copy; 2020 BooksHub, Org. Всі права зареєстровано.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
}
</script>

<style scoped>
</style>
